// import HeaderMethod from '../../components/Sidebar/HeaderMethod';
import HomeNavSidebar from '../../components/Sidebar/HomeNavSidebar';
import TagsGallery from '../../components/TagsGallery';
import TabbedCarousel from '../../components/TabbedCarousel';

const imgs = [
  'https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/banners/banner1.webp',
  'https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/banners/banner2.webp',
  'https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/banners/banner3.webp',
  'https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/banners/banner4.webp',
  'https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/banners/banner5.webp',
];

const HomeScreen = () => {
  return (
    <div class="homescreen" 
    style={{
    backgroundImage: `url("https://furupura-assets.s3.ap-northeast-1.amazonaws.com/samples/backgrounds/background.webp")`,
    height: '100%',
    width: '100%',
    backgroundRepeat: 'repeat',
    overflow: 'hidden',
  }}>
      {/* <div className='home-top'>
        <HeaderMethod/>
      </div> */}
      <div className="home-topcarousel">
        <TabbedCarousel images={imgs} autoplay={4000}/>
      </div> 
      <div className="home-content">
        <div className='home-wrapper'>
          <div className='home-left'>
              <HomeNavSidebar />
          </div>
          <div className='home-right'>
              <TagsGallery/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeScreen